import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=cc3074d4&scoped=true&lang=pug&"
import script from "./tabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./tabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./tabs.vue?vue&type=style&index=0&id=cc3074d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3074d4",
  null
  
)

export default component.exports